import { defineComponent as _defineComponent } from 'vue'
import { JointOption } from '@/modules/ConfiguratorJoints/composables/useOptions';

interface Props {
    options: JointOption[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionsPreview',
  props: {
    options: null
  },
  setup(__props: any) {

const props = __props as {
    options: JointOption[];
};



return { __sfc: true,props }
}

})